var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessManagementTodolistSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "todolist"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5,4H18V2.5a.5.5,0,0,0-1,0V4H7V2.5a.5.5,0,0,0-1,0V4H3.5A1.5,1.5,0,0,0,2,5.5v15A1.5,1.5,0,0,0,3.5,22h17A1.5,1.5,0,0,0,22,20.5V5.5A1.5,1.5,0,0,0,20.5,4ZM21,20.5a.5.5,0,0,1-.5.5H3.5a.5.5,0,0,1-.5-.5V5.5A.5.5,0,0,1,3.5,5H6v.5a.5.5,0,0,0,1,0V5H17v.5a.5.5,0,0,0,1,0V5h2.5a.5.5,0,0,1,.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,10h-5a.5.5,0,0,0,0,1h5a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.15,8.15,15.5,10.79,13.85,9.15a.49.49,0,0,0-.7.7l2,2a.48.48,0,0,0,.7,0l3-3a.49.49,0,1,0-.7-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,17h-5a.5.5,0,0,0,0,1h5a.5.5,0,0,0,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.15,15.15,15.5,17.79l-1.65-1.64a.49.49,0,0,0-.7.7l2,2a.48.48,0,0,0,.7,0l3-3a.49.49,0,1,0-.7-.7Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessManagementTodolistSvgrepoCom);
export default __webpack_public_path__ + "static/media/business-management-todolist-svgrepo-com.c4e398f8ee1ac5fb534ea3da035cc428.svg";
export { ForwardRef as ReactComponent };